(() => {
  const link = document.querySelector('[data-nov-chat]');
  if (!link || link.dataset.chatBound) return;
  link.dataset.chatBound = 'true';
  const mobile = window.matchMedia('(max-width: 749px)');
  let api;
  let opened = false;
  let pending = false;
  let retry;
  let fallback;
  const sync = () => {
    document.body.classList.toggle('nov-chat-open', mobile.matches && opened);
    link.setAttribute('aria-expanded', String(opened));
    if (api) {
      if (mobile.matches && !opened && !pending) api.hide();
      else api.show();
    }
  };
  const launch = () => {
    api.show();
    setTimeout(() => api.open(), 150);
  };
  const ready = () => {
    if (api || !window.tidioChatApi || typeof window.tidioChatApi.getStatus !== 'function' || window.tidioChatApi.getStatus() == null) return;
    api = window.tidioChatApi;
    api.on('open', () => {
      opened = true;
      pending = false;
      clearInterval(retry);

      link.removeAttribute('aria-busy');
      sync();
    });
    api.on('close', () => { clearTimeout(fallback); clearInterval(retry); opened = false; pending = false; sync(); });
    if (pending) launch();
    else sync();
  };
  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', ready);
    ready();
  }
  document.addEventListener('tidioChat-ready', ready);
  link.addEventListener('click', event => {
    if (!mobile.matches) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    link.setAttribute('aria-busy', 'true');
    ready();
    if (api) launch();
    else retry = setInterval(ready, 500);
    fallback = setTimeout(() => {
      const frame = document.getElementById('tidio-chat-iframe');
      if (opened && frame && frame.getBoundingClientRect().width > 150) return;
      opened = false;
      clearInterval(retry);
      pending = false;
      link.removeAttribute('aria-busy');
      sync();
      window.location.assign(link.href);
    }, 8000);
  });
  mobile.addEventListener('change', sync);
})();
